import { useRef, useState, useEffect } from "react";
import CustomScroller from "../../../../shadcn/components/custom/CustomScroller";
interface props {
  className?: string;
  blogsData: BlogsData[];
}

import { BlogsScrollerCard } from "../../../../shadcn/components/custom/BlogsScrollerCard";

interface BlogsData {
  date?: string;
  title?: string;
  description?: string;
  imageLink?: string;
  link?: string;
  category?: string;
}

export const BlogsScroller = ({ className, blogsData }: props) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [activeBar, setActiveBar] = useState(1);
  const x = 90;

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const updateScrollPosition = () => {
      const scrollPercentage =
        1 *
        (scrollContainer.scrollLeft /
          (scrollContainer.scrollWidth - scrollContainer.clientWidth)) *
        100;
      scrollContainer.style.setProperty(
        "--scroll-position",
        `${2.3 * scrollPercentage}%`,
      );
      //   logic for adjusting the width of the background bar

      if (scrollPercentage < 33) setActiveBar(1);
      else if (scrollPercentage < 67) setActiveBar(2);
      else setActiveBar(3);
    };

    scrollContainer.addEventListener("scroll", updateScrollPosition);
    return () =>
      scrollContainer.removeEventListener("scroll", updateScrollPosition);
  }, []);

  return (
    <div className="relative overflow-auto">
      <CustomScroller
        ref={scrollContainerRef}
        className={`pb-[75px] ${className}`}
      >
        {blogsData.map((card, index) => (
          <div key={`blogs_${index}`} className={`min-w-[383px] mr-[58px]`}>
            <BlogsScrollerCard
              title={card?.title}
              tag={card?.category}
              tagBgClasses="font-openSans text-web-body-sm text-center text-white font-semibold leading-6 bg-[#FF752C] w-[191px] py-2 h-[41px] clip-path-topRightFourSided"
              textContent={card?.description}
              blogDate={card?.date}
              imageLink={card?.imageLink}
              blogLink={card?.link}
            />
          </div>
        ))}
        {/* Custom Scrollbar */}
        <ul className="absolute flex bottom-0 justify-center gap-10 left-1/3">
          <li
            className={`w-[90px] h-1 ${
              activeBar == 1 ? "bg-brand-textBlack" : "bg-[#A8A8A8]"
            }`}
          />
          <li
            className={`w-[90px] h-1 ${
              activeBar == 2 ? "bg-brand-textBlack" : "bg-[#A8A8A8]"
            }`}
          />
          <li
            className={`w-[90px] h-1 ${
              activeBar == 3 ? "bg-brand-textBlack" : "bg-[#A8A8A8]"
            }`}
          />
        </ul>
      </CustomScroller>
    </div>
  );
};
